import React, { useState } from 'react';
import linkedinIcon from '../assets/linkedin-icon.svg';
import LegalModal from './LegalModal';


const impressumText = `
  <p><strong>Impressum</strong></p>
  <p>
(Angaben gemäß § 5 TMG)
Verantwortlich für den Inhalt:
Maximilian Bunte<br/>
Franz-Lieder-Straße 3, 40593 Düsseldorf, Germany
E-Mail: contact@qlance.de
<br/>
<br/>Vertretungsberechtigt:<br/>
Maximilian Bunte<br/>
Firma: Qlance GmbH<br/>
Handelsregister: Amtsgericht Düsseldorf<br/>
Handelsregister-Nummer: HRB 110327<br/>
Steuernummer: 5106-5722-1008<br/>
<br/>
Verantwortlich im Sinne des § 18 Abs. 2 MStV:
Maximilian Bunte
[Adresse wie oben]
<br/>
<br/>Haftung für Inhalte<br/>
Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8–10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
<br/>
<br/>Haftung für Links
<br/>Diese Website enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden Inhalte auch keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
<br/>
<br/>Urheberrecht<br/>
Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung oder sonstige Nutzung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
</p>
`;

const datenschutzText = `
  <p><strong>Datenschutzerklärung</strong></p>
  <p>
Stand: 05.10.2025
Hinweis: Diese Datenschutzerklärung enthält vorläufige Platzhalter für einzelne gesetzlich erforderliche Angaben (z. B. Geschäftsadresse). Die endgültige Version wird bei Abschluss der Gründung und Vorliegen aller Daten entsprechend angepasst.<br/>
<br/>
1. Verantwortlicher gemäß Art. 4 Nr. 7 DSGVO
Qlance GmbH 
Vertreten durch: Maximilian Bunte
Franz-Lieder-Straße 3, 40593 Düsseldorf, Germany
E-Mail: contact@qlance.de<br/>
Handelsregister: HRB 110327 <br/>
Steuernummer: 5106-5722-1008<br/>
<br/>
2. Hosting der Website
Unsere Website wird gehostet von:
Vercel Inc.
440 N Barranca Ave #4133
Covina, CA 91723, USA<br/>
Beim Besuch der Website werden automatisch technische Zugriffsdaten erfasst (z. B. IP-Adresse, Uhrzeit, verwendeter Browser).
Eine Übermittlung personenbezogener Daten in die USA ist möglich. Vercel verpflichtet sich zur Einhaltung der geltenden Datenschutzvorgaben nach Art. 44 ff. DSGVO, u. a. über Standardvertragsklauseln der EU-Kommission (SCCs).
<br/><br/>
3. Kontaktaufnahme über das Formular
Bei Nutzung unseres Kontaktformulars verarbeiten wir folgende personenbezogene Daten:<br/>
Name<br/>


E-Mail-Adresse<br/>


Ihre Nachricht<br/>


(optional) Telefonnummer<br/>

<br/>
Die übermittelten Daten werden nicht dauerhaft gespeichert, sondern ausschließlich zur Beantwortung Ihrer Anfrage verwendet und danach gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
Der E-Mail-Versand erfolgt über:<br/>
IONOS (1&1 Mail & Media GmbH)<br/>
Elgendorfer Str. 57<br/>
56410 Montabaur, Deutschland<br/>
Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Kommunikation und Support).<br/>
<br/>
4. Eingebundene Inhalte & Dienste Dritter<br/>
Unsere Website ist bewusst datensparsam gestaltet. Es gilt:<br/>
Keine externen Trackingdienste oder Analyse-Tools (wie Google Analytics)<br/>


Keine Cookies oder Web Beacons<br/>


Schriftarten („Inter“, „Josefin Sans“) sind lokal eingebunden<br/>


Icons und Bilder werden lokal gespeichert<br/>


Es werden keine eingebetteten Inhalte von Drittseiten (z. B. YouTube, Google Maps, LinkedIn) geladen<br/>


<br/>
5. Ihre Rechte gemäß DSGVO<br/>
Sie haben das Recht auf:<br/>
Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)<br/>


Berichtigung unrichtiger Daten (Art. 16 DSGVO)<br/>


Löschung Ihrer Daten (Art. 17 DSGVO)<br/>


Einschränkung der Verarbeitung (Art. 18 DSGVO)<br/>


Datenübertragbarkeit (Art. 20 DSGVO)<br/>


Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)<br/>


Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)<br/>

<br/>
Zuständige Aufsichtsbehörde:<br/>
Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br/>
Kavalleriestraße 2–4, 40213 Düsseldorf<br/>
<br/>
6. Datenschutzkontakt<br/>
Qlance GmbH<br/>
Maximilian Bunte<br/>
Franz-Lieder-Straße 3, 40593 Düsseldorf, Germany<br/>
E-Mail: contact@qlance.de</p><br/>
  <p>Bei Fragen wenden Sie sich bitte an: contact@qlance.de</p>
`;

const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setModalOpen(true);
  };

  return (
    <>
      <footer className="footer" id="footer">
                {/* heyData GDPR Seal */}
        <div className="heydata-wrapper">
          <a
            href="https://heydata.eu"
            target="_blank"
            rel="noopener noreferrer"
            title="heyData GDPR seal"
          >
            <img
              alt="heyData trusted logo"
              src="https://privacy-seal.heydata.eu/seal/e8467ea7-4a7b-41e5-b636-fbb1cbc3f7a6?lang=de&design=design1&sealType=GDPR"
            />
          </a>
        </div>
         <div className="footer-divider"></div>
        <div className="footer-container">
          <div className="footer-left">
            <p>© 2025 Qlance – work smarter, match better.</p>
          </div>

          <nav className="footer-links">
            <a href="#contact">Kontakt</a>
            <a href="#" onClick={(e) => { e.preventDefault(); openModal("Impressum", impressumText); }}>
                Impressum
              </a>
              <a href="#" onClick={(e) => { e.preventDefault(); openModal("Datenschutz", datenschutzText); }}>
                Datenschutz
              </a>
          </nav>

          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/company/qlancegmbh/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Qlance auf LinkedIn"
            >
              <img src={linkedinIcon} alt="LinkedIn Icon" />
            </a>
             {/* <a
              href="https://www.linkedin.com/in/michael-bunte-63924743/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Constantin auf LinkedIn"
            >
              <img src={linkedinIcon} alt="LinkedIn Icon" />
            </a> */}
          </div>
        </div>
      </footer>

      <LegalModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={modalTitle}
        content={modalContent}
      />
    </>
  );
};

export default Footer;
